import { useTranslation } from "next-i18next";
import { FunctionComponent } from "react";

import styles from "./Symbol.module.scss";

import SymbolIcon from "@components/generic/symbolIcon";
import { eSymbol, selectTextSymbols } from "@lib/helper/symbolUtils";

export interface ISymbolProps {
  symbol: eSymbol;
  percentage?: number;
  className?: string;
}

const Symbol: FunctionComponent<ISymbolProps> = ({ symbol, percentage, className }) => {
  const { t } = useTranslation("common");

  const textSymbol = selectTextSymbols(symbol, percentage);

  return (
    <div className={`${className} ${styles["symbol"]}`}>
      <SymbolIcon symbol={symbol} percentage={percentage} className={styles["symbol__icon"]} />
      <p className={styles["symbol__text"]}>{t(textSymbol)}</p>
    </div>
  );
};

export default Symbol;
